import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import Papa from "papaparse";
import TagViewComponent from "./component";

const TagViewDetailsContainer = (props) => {
  const { corporateId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  // State variables
  const [tagData, setTagData] = useState(null);
  const [allTags, setAllTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [corporateName, setCorporateName] = useState("");
  const [selectedTags, setSelectedTags] = useState({});
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  
  // Search and Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTags, setFilteredTags] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [activeTab, setActiveTab] = useState("active");
  
  // Not Activated Select All states
  const [notActivatedSelectedCount, setNotActivatedSelectedCount] = useState(0);
  const [notActivatedTotalCount, setNotActivatedTotalCount] = useState(0);
  const [notActivatedAllSelected, setNotActivatedAllSelected] = useState(false);
  
  // Filter states
  const [showDepartmentFilter, setShowDepartmentFilter] = useState(false);
  const [showBalanceFilter, setShowBalanceFilter] = useState(false);
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [balanceFilterType, setBalanceFilterType] = useState("");
  const [balanceAmount, setBalanceAmount] = useState("");
  const [tempBalanceFilterType, setTempBalanceFilterType] = useState("");
  const [tempBalanceAmount, setTempBalanceAmount] = useState("");
  const [departments, setDepartments] = useState([]);
  const [isBalanceFilterApplied, setIsBalanceFilterApplied] = useState(false);
  
  // Department List for Change Department Popup
  const [departmentListForPopup, setDepartmentListForPopup] = useState([]);
  
  // Recharge Modal States
  const [showRechargeModal, setShowRechargeModal] = useState(false);
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [reason, setReason] = useState("");
  const [rechargeLoading, setRechargeLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [rechargeResult, setRechargeResult] = useState(null);
  
  // Deactivate Confirmation Modal States
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [deactivateLoading, setDeactivateLoading] = useState(false);
  
  // Activate Success Popup States
  const [showActivateSuccessPopup, setShowActivateSuccessPopup] = useState(false);
  const [activateResult, setActivateResult] = useState(null);
  
  // Change Department Modal States
  const [showDeptModal, setShowDeptModal] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [selectedDepartmentName, setSelectedDepartmentName] = useState("");
  const [deptSearchTerm, setDeptSearchTerm] = useState("");
  const [deptChangeLoading, setDeptChangeLoading] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [showDeptDropdown, setShowDeptDropdown] = useState(false);
  const [deptSuccessPopup, setDeptSuccessPopup] = useState(false);
  const [deptChangeResult, setDeptChangeResult] = useState(null);
  
  // Bulk Upload States
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [bulkUploading, setBulkUploading] = useState(false);
  const [bulkUploadProgress, setBulkUploadProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [csvOriginalData, setCsvOriginalData] = useState({});
  const [bulkUploadHeading, setBulkUploadHeading] = useState("Upload Tag in bulk");

  // Fetch department data for change department popup
  const fetchDepartmentData = useCallback(() => {
    props.getDataFromAPI(
      `/partner/api/v1/corp/${corporateId}/details`,
      "GET",
      undefined,
      (response) => {
        console.log("Department API Response:", response);
        
        let departmentsList = [];
        
        if (response && response.departments && Array.isArray(response.departments)) {
          departmentsList = response.departments;
        } else if (response && response && response.departments) {
          departmentsList = response.departments;
        } else if (Array.isArray(response)) {
          departmentsList = response;
        }
        
        const formattedDepartments = departmentsList.map(dept => ({
          id: dept.departmentId !== undefined ? dept.departmentId : (dept.id !== undefined ? dept.id : 0),
          name: dept.departmentName || dept.name 
        }));
        
        const hasDefault = formattedDepartments.some(d => d.id === 0);
        if (!hasDefault) {
          formattedDepartments.unshift({ id: 0, name: "Default" });
        }
        
        setDepartmentListForPopup(formattedDepartments);
        console.log("Formatted Departments for Popup:", formattedDepartments);
      },
      (error) => {
        console.error("Error fetching departments:", error);
        if (departments.length > 0) {
          setDepartmentListForPopup(departments);
        } else {
          setDepartmentListForPopup([{ id: 0, name: "Default" }]);
        }
      }
    );
  }, [corporateId, props, departments]);

  // Fetch tags from API with pagination
  const fetchTags = useCallback((page = 0, isLoadMore = false) => {
    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
      setAllTags([]);
      setCurrentPage(0);
    }
    
    props.getDataFromAPI(
      `/partner/api/v2/corporates/${corporateId}/tags?page=${page}&size=100`,
      "GET",
      undefined,
      (response) => {
        console.log("Tags API Response:", response);
        
        let tags = [];
        let totalPagesCount = 0;
        let totalElementsCount = 0;
        
        if (response?.content) {
          tags = response.content;
          totalPagesCount = response.totalPages || 0;
          totalElementsCount = response.totalElements || 0;
        } else if (response?.content) {
          tags = response.content;
          totalPagesCount = response.totalPages || 0;
          totalElementsCount = response.totalElements || 0;
        } else if (Array.isArray(response)) {
          tags = response;
        } else if (response) {
          tags = response;
        }
        
        setTotalPages(totalPagesCount);
        setTotalElements(totalElementsCount);
        setHasMore(page + 1 < totalPagesCount);
        
        if (isLoadMore) {
          setAllTags(prev => [...prev, ...tags]);
          setCurrentPage(page);
        } else {
          setAllTags(tags);
          setCurrentPage(page);
        }
        
        const allTagsList = isLoadMore ? [...allTags, ...tags] : tags;
        const uniqueDepts = [...new Set(allTagsList.map(tag => tag.department_name || tag.department).filter(Boolean))];
        const deptList = uniqueDepts.map((dept, idx) => ({ id: idx + 1, name: dept }));
        setDepartments(deptList);
        
        if (isLoadMore) {
          setLoadingMore(false);
        } else {
          setLoading(false);
        }
      },
      (error) => {
        console.error("Error fetching tags:", error);
        toastr.error("Error", "Unable to fetch tags");
        if (isLoadMore) {
          setLoadingMore(false);
        } else {
          setLoading(false);
        }
      }
    );
  }, [corporateId, props]);

  // Load more tags
  const handleLoadMore = () => {
    if (!loadingMore && hasMore) {
      fetchTags(currentPage + 1, true);
    }
  };

  // Apply filters based on status
  const applyFilters = useCallback(() => {
    let filtered = allTags || [];
    
    if (activeTab === 'active') {
      filtered = filtered.filter(tag => tag.status === 'active');
    } else if (activeTab === 'inactive') {
      filtered = filtered.filter(tag => tag.status === 'inactive');
    } else if (activeTab === 'notActivated') {
      filtered = filtered.filter(tag => tag.status === 'new');
    }
    
    if (searchTerm.trim()) {
      filtered = filtered.filter(tag => 
        tag.uid?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (departmentFilter) {
      filtered = filtered.filter(tag => 
        (tag.department_name || tag.department) === departmentFilter
      );
    }
    
    if (isBalanceFilterApplied && balanceFilterType && balanceAmount) {
      const amount = parseFloat(balanceAmount);
      if (!isNaN(amount)) {
        if (balanceFilterType === 'above') {
          filtered = filtered.filter(tag => (tag.balance || 0) > amount);
        } else if (balanceFilterType === 'below') {
          filtered = filtered.filter(tag => (tag.balance || 0) < amount);
        }
      }
    }
    
    setFilteredTags(filtered);
  }, [allTags, activeTab, searchTerm, departmentFilter, isBalanceFilterApplied, balanceFilterType, balanceAmount]);

  // Clear selected tags when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedTags({});
    setSelectAll(false);
  };

  // Update selectAll when filteredTags or selectedTags change
  useEffect(() => {
    if (filteredTags.length > 0 && selectedTags) {
      const allSelected = filteredTags.every(tag => selectedTags[tag.id || tag.uid]);
      setSelectAll(allSelected);
    } else {
      setSelectAll(false);
    }
  }, [selectedTags, filteredTags]);

  // Update Not Activated Select All counts
  useEffect(() => {
    if (activeTab === 'notActivated') {
      const notActivatedTags = filteredTags.filter(tag => tag.status === 'new');
      const total = notActivatedTags.length;
      const selected = notActivatedTags.filter(tag => selectedTags[tag.id || tag.uid]).length;
      setNotActivatedTotalCount(total);
      setNotActivatedSelectedCount(selected);
      setNotActivatedAllSelected(total > 0 && selected === total);
    }
  }, [filteredTags, selectedTags, activeTab]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Initial fetch
  useEffect(() => {
    if (corporateId) {
      fetchTags(0, false);
      fetchDepartmentData();
      if (location.state?.corporateName) {
        setCorporateName(location.state.corporateName);
      }
    }
  }, [corporateId]);

  // Filter departments for search in popup
  useEffect(() => {
    if (deptSearchTerm) {
      const filtered = departmentListForPopup.filter(dept => 
        dept.name.toLowerCase().includes(deptSearchTerm.toLowerCase())
      );
      setFilteredDepartments(filtered);
      setShowDeptDropdown(true);
    } else {
      setFilteredDepartments(departmentListForPopup);
      setShowDeptDropdown(true);
    }
  }, [deptSearchTerm, departmentListForPopup]);

  // Group selected tags by department for APIs
  const groupTagsByDepartment = (selectedTagsList) => {
    const grouped = {};
    
    Object.values(selectedTagsList).forEach(tag => {
      let deptId = tag.department_id !== undefined ? tag.department_id : null;
      
      if (deptId === null || deptId === undefined) {
        if (tag.department_name) {
          const foundDept = departmentListForPopup.find(d => d.name === tag.department_name);
          if (foundDept) {
            deptId = foundDept.id;
          } else {
            deptId = 0;
          }
        } else {
          deptId = 0;
        }
      }
      
      if (!grouped[deptId]) {
        grouped[deptId] = {
          departmentId: deptId,
          uids: []
        };
      }
      
      const uid = tag.uid;
      if (uid && !grouped[deptId].uids.includes(uid)) {
        grouped[deptId].uids.push(uid);
      }
    });
    
    return Object.values(grouped);
  };

  // ============ BULK UPLOAD HANDLERS ============
  const handleOpenBulkUploadModal = () => {
    setShowBulkUploadModal(true);
    setSelectedFile(null);
    setBulkUploading(false);
    setBulkUploadProgress(0);
    setBulkUploadHeading("Upload Tag in bulk");
  };

  const handleCloseBulkUploadModal = () => {
    setShowBulkUploadModal(false);
    setSelectedFile(null);
    setBulkUploading(false);
    setBulkUploadHeading("Upload Tag in bulk");
  };

  const handleFileSelect = (file) => {
    if (!file) return;
    if (file.type !== "text/csv" && !file.name.endsWith('.csv')) {
      toastr.error("Error", "Please upload a CSV file only");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toastr.error("Error", "File size should be less than 5MB");
      return;
    }
    setSelectedFile(file);
    setBulkUploadHeading("Uploaded");
  };

  const handleCancelFile = () => {
    setSelectedFile(null);
    setBulkUploadHeading("Upload Tag in bulk");
  };

  const handleBulkFileUpload = (file) => {
    if (!file) return;
    
    setBulkUploading(true);
    setBulkUploadProgress(0);
    
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const csvData = results.data;
        const originalDeptMap = {};
        
        csvData.forEach(row => {
          const uid = row.uid?.trim();
          const deptId = row.department_id?.trim();
          if (uid && deptId) {
            originalDeptMap[uid] = parseInt(deptId);
          }
        });
        
        setCsvOriginalData(originalDeptMap);
        
        const formData = new FormData();
        formData.append('file', file);
        
        const interval = setInterval(() => {
          setBulkUploadProgress(prev => Math.min(prev + 10, 90));
        }, 200);
        
        props.getDataFromAPI(
          `/partner/api/v2/corporates/${corporateId}/tag/bulk`,
          "POST",
          formData,
          (response) => {
            clearInterval(interval);
            setBulkUploadProgress(100);
            
            const apiData = response || response || [];
            
            if (apiData.length === 0) {
              toastr.warning("Warning", "No tags were created");
              setBulkUploading(false);
              setShowBulkUploadModal(false);
              setSelectedFile(null);
              setBulkUploadHeading("Upload Tag in bulk");
              return;
            }
            
            toastr.success("Success", `${apiData.length} tags uploaded successfully`);
            setBulkUploading(false);
            setShowBulkUploadModal(false);
            setSelectedFile(null);
            setBulkUploadHeading("Upload Tag in bulk");
            fetchTags(0, false);
            fetchDepartmentData();
          },
          (err) => {
            clearInterval(interval);
            setBulkUploadProgress(0);
            setBulkUploading(false);
            toastr.error("Error", err?.message || "Failed to upload tags");
          }
        );
      },
      error: (error) => {
        console.error("CSV Parse Error:", error);
        toastr.error("Error", "Failed to parse CSV file");
        setBulkUploading(false);
      }
    });
  };

  // ============ NOT ACTIVATED SELECT ALL HANDLER ============
  const handleNotActivatedSelectAll = () => {
    if (notActivatedAllSelected) {
      setSelectedTags({});
      setNotActivatedAllSelected(false);
      setNotActivatedSelectedCount(0);
    } else {
      const allTagIds = {};
      filteredTags.forEach(tag => {
        if (tag.status === 'new') {
          allTagIds[tag.id || tag.uid] = tag;
        }
      });
      setSelectedTags(allTagIds);
      setNotActivatedAllSelected(true);
      setNotActivatedSelectedCount(Object.keys(allTagIds).length);
    }
  };

  // Handlers
  const handleBackClick = () => navigate(-1);
  const handleEditTag = (tag) => navigate(`/home/walletandtags/tag-usage-history/${tag.uid}`);
  const handleBulkUpload = () => handleOpenBulkUploadModal();

  const handleSelectTag = (tag) => {
    const tagId = tag.id || tag.uid;
    setSelectedTags(prev => {
      const newSelected = { ...prev };
      if (newSelected[tagId]) {
        delete newSelected[tagId];
      } else {
        newSelected[tagId] = tag;
      }
      return newSelected;
    });
  };

  const handleSelectAll = (tags, isSelected) => {
    if (isSelected) {
      const newSelected = {};
      tags.forEach(tag => {
        const tagId = tag.id || tag.uid;
        newSelected[tagId] = tag;
      });
      setSelectedTags(newSelected);
    } else {
      setSelectedTags({});
    }
  };

  // Activate API for Not Activated tab
  const handleActivateSelected = (selected) => {
    const tagIds = Object.keys(selected);
    if (tagIds.length === 0) {
      toastr.warning("No Selection", "Please select tags to activate");
      return;
    }
    
    const requestBody = groupTagsByDepartment(selected);
    console.log("Activate Request Body:", requestBody);
    
    props.getDataFromAPI(
      `/partner/api/v2/corporates/${corporateId}/tag/bulk/activate`,
      "PUT",
      requestBody,
      (response) => {
        const data = response || response;
        const successCount = data?.success_count || tagIds.length;
        const failureCount = data?.failure_count || 0;
        
        setActivateResult({
          success: true,
          successCount: successCount,
          failureCount: failureCount,
          totalCount: tagIds.length,
          failedDetails: data?.failed_details || []
        });
        setShowActivateSuccessPopup(true);
        
        if (successCount > 0) {
          toastr.success("Success", `${successCount} tags activated successfully`);
        }
        if (failureCount > 0) {
          toastr.warning("Warning", `${failureCount} tags failed to activate`);
        }
        
        fetchTags(0, false);
        setSelectedTags({});
      },
      (error) => {
        setActivateResult({
          success: false,
          message: error?.message || "Failed to activate tags",
          totalCount: tagIds.length
        });
        setShowActivateSuccessPopup(true);
        toastr.error("Error", error?.message || "Failed to activate tags");
      }
    );
  };

  // Activate API for Inactive tab (Reactivate)
  const handleConfirmActivate = (selected) => {
    const tagIds = Object.keys(selected);
    if (tagIds.length === 0) {
      toastr.warning("No Selection", "Please select tags to activate");
      return;
    }
    
    const grouped = groupTagsByDepartment(selected);
    let totalSuccess = 0;
    let totalFailed = 0;
    let pendingCalls = grouped.length;
    
    if (pendingCalls === 0) {
      toastr.error("Error", "No valid department IDs found");
      return;
    }
    
    grouped.forEach(group => {
      const requestBody = {
        card_status: "Active",
        departments: [
          {
            departmentId: group.departmentId,
            uids: group.uids
          }
        ]
      };
      
      props.getDataFromAPI(
        `/partner/api/v2/corporates/${corporateId}/tags/status`,
        "PATCH",
        requestBody,
        (response) => {
          const data = response || response;
          const successCount = data?.success_count || group.uids.length;
          const failedCount = data?.failure_count || 0;
          totalSuccess += successCount;
          totalFailed += failedCount;
          pendingCalls--;
          
          if (pendingCalls === 0) {
            setActivateResult({
              success: true,
              successCount: totalSuccess,
              failureCount: totalFailed,
              totalCount: tagIds.length,
              failedDetails: []
            });
            setShowActivateSuccessPopup(true);
            
            if (totalSuccess > 0) {
              toastr.success("Success", `${totalSuccess} tags activated successfully`);
            }
            if (totalFailed > 0) {
              toastr.warning("Warning", `${totalFailed} tags failed to activate`);
            }
            fetchTags(0, false);
            setSelectedTags({});
          }
        },
        (error) => {
          totalFailed += group.uids.length;
          pendingCalls--;
          
          if (pendingCalls === 0) {
            setActivateResult({
              success: false,
              message: error?.message || "Failed to activate tags",
              totalCount: tagIds.length
            });
            setShowActivateSuccessPopup(true);
            toastr.error("Error", error?.message || "Failed to activate tags");
          }
        }
      );
    });
  };

  // Open Deactivate Confirmation Modal
  const handleOpenDeactivateModal = () => {
    if (Object.keys(selectedTags).length === 0) {
      toastr.warning("No Selection", "Please select tags to deactivate");
      return;
    }
    setShowDeactivateModal(true);
  };

  const handleCloseDeactivateModal = () => {
    setShowDeactivateModal(false);
  };

  const handleConfirmDeactivate = () => {
    setDeactivateLoading(true);
    const grouped = groupTagsByDepartment(selectedTags);
    
    let totalSuccess = 0;
    let totalFailed = 0;
    let pendingCalls = grouped.length;
    
    if (pendingCalls === 0) {
      toastr.error("Error", "No valid department IDs found");
      setDeactivateLoading(false);
      setShowDeactivateModal(false);
      return;
    }
    
    grouped.forEach(group => {
      const requestBody = {
        card_status: "Inactive",
        departments: [
          {
            departmentId: group.departmentId,
            uids: group.uids
          }
        ]
      };
      
      props.getDataFromAPI(
        `/partner/api/v2/corporates/${corporateId}/tags/status`,
        "PATCH",
        requestBody,
        (response) => {
          const data = response || response;
          const successCount = data?.success_count || group.uids.length;
          const failedCount = data?.failure_count || 0;
          totalSuccess += successCount;
          totalFailed += failedCount;
          pendingCalls--;
          
          if (pendingCalls === 0) {
            setDeactivateLoading(false);
            setShowDeactivateModal(false);
            
            if (totalSuccess > 0) {
              toastr.success("Success", `${totalSuccess} tags deactivated successfully`);
            }
            if (totalFailed > 0) {
              toastr.error("Error", `${totalFailed} tags failed to deactivate`);
            }
            fetchTags(0, false);
            setSelectedTags({});
          }
        },
        (error) => {
          totalFailed += group.uids.length;
          pendingCalls--;
          
          if (pendingCalls === 0) {
            setDeactivateLoading(false);
            setShowDeactivateModal(false);
            
            if (totalSuccess > 0) {
              toastr.success("Success", `${totalSuccess} tags deactivated successfully`);
            }
            if (totalFailed > 0) {
              toastr.error("Error", `${totalFailed} tags failed to deactivate`);
            }
            fetchTags(0, false);
            setSelectedTags({});
          }
        }
      );
    });
  };

  // Search handlers
  const handleSearchChange = (value) => setSearchTerm(value);
  const handleSearch = () => applyFilters();

  // Department filter handlers
  const handleToggleDepartmentFilter = () => setShowDepartmentFilter(!showDepartmentFilter);
  const handleDepartmentFilterChange = (value) => {
    setDepartmentFilter(value);
    setShowDepartmentFilter(false);
  };
  const handleClearDepartmentFilter = () => {
    setDepartmentFilter("");
    setShowDepartmentFilter(false);
  };

  // Balance filter handlers
  const handleToggleBalanceFilter = () => {
    setTempBalanceFilterType(balanceFilterType);
    setTempBalanceAmount(balanceAmount);
    setShowBalanceFilter(!showBalanceFilter);
  };
  const handleTempBalanceFilterTypeChange = (value) => setTempBalanceFilterType(value);
  const handleTempBalanceAmountChange = (value) => setTempBalanceAmount(value);
  const handleApplyBalanceFilter = () => {
    setBalanceFilterType(tempBalanceFilterType);
    setBalanceAmount(tempBalanceAmount);
    setIsBalanceFilterApplied(true);
    setShowBalanceFilter(false);
  };
  const handleClearBalanceFilter = () => {
    setTempBalanceFilterType("");
    setTempBalanceAmount("");
    setBalanceFilterType("");
    setBalanceAmount("");
    setIsBalanceFilterApplied(false);
    setShowBalanceFilter(false);
  };

  // ============ RECHARGE MODAL HANDLERS WITH 5-DIGIT LIMIT ============
  const handleOpenRechargeModal = () => {
    if (Object.keys(selectedTags).length === 0) {
      toastr.warning("No Selection", "Please select tags to recharge");
      return;
    }
    setRechargeAmount("");
    setReason("");
    setShowRechargeModal(true);
  };

  const handleCloseRechargeModal = () => {
    setShowRechargeModal(false);
    setRechargeAmount("");
    setReason("");
  };

  const handleRechargeAmountChange = (value) => {
    // Allow empty string
    if (value === "") {
      setRechargeAmount("");
      return;
    }
    
    // Remove any non-digit characters
    let cleanedValue = value.replace(/[^0-9]/g, '');
    
    // Limit to 5 digits (max 99999)
    if (cleanedValue.length > 5) {
      cleanedValue = cleanedValue.slice(0, 5);
    }
    
    setRechargeAmount(cleanedValue);
  };

  const handleReasonChange = (value) => setReason(value);

  const handleSubmitRecharge = () => {
    const amount = parseFloat(rechargeAmount);
    
    if (!rechargeAmount || isNaN(amount)) {
      toastr.warning("Warning", "Please enter a valid recharge amount");
      return;
    }
    
    if (amount < 100) {
      toastr.warning("Warning", "Minimum recharge amount is ₹100 per tag");
      return;
    }
    
    if (amount > 99999) {
      toastr.warning("Warning", "Maximum recharge amount is ₹99,999 per tag (5 digits only)");
      return;
    }
    
    if (!reason.trim()) {
      toastr.warning("Warning", "Please enter a reason for recharge");
      return;
    }
    
    setRechargeLoading(true);
    const selectedTagsList = Object.values(selectedTags);
    
    const grouped = {};
    selectedTagsList.forEach(tag => {
      let deptId = tag.department_id;
      if (deptId === undefined || deptId === null) {
        if (tag.department_name) {
          const foundDept = departmentListForPopup.find(d => d.name === tag.department_name);
          if (foundDept) {
            deptId = foundDept.id;
          } else {
            deptId = 0;
          }
        } else {
          deptId = 0;
        }
      }
      
      if (!grouped[deptId]) {
        grouped[deptId] = [];
      }
      grouped[deptId].push({
        uid: tag.uid,
        amount: amount
      });
    });
    
    const departmentsArray = Object.keys(grouped).map(deptId => ({
      departmentId: parseInt(deptId),
      details: grouped[deptId]
    }));
    
    const requestBody = {
      reason: reason,
      departments: departmentsArray
    };
    
    props.getDataFromAPI(
      `/partner/api/v2/corporates/${corporateId}/tag/bulk/recharge`,
      "POST",
      requestBody,
      (response) => {
        setRechargeLoading(false);
        setShowRechargeModal(false);
        const data = response || response;
        const successCount = data?.success_count || selectedTagsList.length;
        setRechargeResult({
          success: true,
          successCount: successCount,
          totalCount: selectedTagsList.length,
          amount: rechargeAmount
        });
        setShowSuccessPopup(true);
        toastr.success("Success", `${successCount} tags recharged successfully`);
        fetchTags(0, false);
        setSelectedTags({});
      },
      (error) => {
        setRechargeLoading(false);
        setShowRechargeModal(false);
        setRechargeResult({ 
          success: false, 
          message: error?.message || "Recharge failed. Please try again.",
          totalCount: Object.keys(selectedTags).length
        });
        setShowSuccessPopup(true);
      }
    );
  };

  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    setRechargeResult(null);
  };
  
  const handleCloseActivateSuccessPopup = () => {
    setShowActivateSuccessPopup(false);
    setActivateResult(null);
  };

  // Change Department Handlers
  const handleOpenDeptModal = () => {
    if (Object.keys(selectedTags).length === 0) {
      toastr.warning("No Selection", "Please select tags to change department");
      return;
    }
    setSelectedDepartmentId("");
    setSelectedDepartmentName("");
    setDeptSearchTerm("");
    setShowDeptModal(true);
  };

  const handleCloseDeptModal = () => {
    setShowDeptModal(false);
    setSelectedDepartmentId("");
    setSelectedDepartmentName("");
    setDeptSearchTerm("");
    setShowDeptDropdown(false);
  };

  const handleSelectDepartment = (dept) => {
    setSelectedDepartmentId(dept.id);
    setSelectedDepartmentName(dept.name);
    setDeptSearchTerm(dept.name);
    setShowDeptDropdown(false);
  };

  const handleSubmitDeptChange = () => {
    if (!selectedDepartmentId) {
      toastr.warning("Warning", "Please select a department");
      return;
    }
    
    setDeptChangeLoading(true);
    const selectedTagsList = Object.values(selectedTags);
    const uids = selectedTagsList.map(tag => tag.uid);
    
    const requestBody = {
      department_id: parseInt(selectedDepartmentId),
      uids: uids
    };
    
    props.getDataFromAPI(
      `/partner/api/v2/corporates/${corporateId}/change-department`,
      "PUT",
      requestBody,
      (response) => {
        setDeptChangeLoading(false);
        setShowDeptModal(false);
        
        const data = response || response;
        setDeptChangeResult({
          success: true,
          totalCount: data?.total_count || uids.length,
          successCount: data?.success_count || 0,
          failureCount: data?.failure_count || uids.length,
          failedUids: data?.failed_uids || [],
          targetDepartment: selectedDepartmentName
        });
        setDeptSuccessPopup(true);
        
        if (data?.success_count > 0) {
          toastr.success("Success", `${data.success_count} tags moved successfully to ${selectedDepartmentName}`);
        }
        if (data?.failure_count > 0) {
          toastr.warning("Warning", `${data.failure_count} tags failed to move`);
        }
        
        fetchTags(0, false);
        setSelectedTags({});
      },
      (error) => {
        setDeptChangeLoading(false);
        setShowDeptModal(false);
        setDeptChangeResult({
          success: false,
          message: error?.message || "Failed to change department",
          totalCount: Object.keys(selectedTags).length,
          targetDepartment: selectedDepartmentName
        });
        setDeptSuccessPopup(true);
      }
    );
  };

  const handleCloseDeptSuccessPopup = () => {
    setDeptSuccessPopup(false);
    setDeptChangeResult(null);
  };

  // Calculate counts
  const activeTags = allTags?.filter(tag => tag.status === 'active')?.length || 0;
  const inactiveTags = allTags?.filter(tag => tag.status === 'inactive')?.length || 0;
  const notActivatedTags = allTags?.filter(tag => tag.status === 'new')?.length || 0;
  const selectedCount = Object.keys(selectedTags).length;
  
  const selectedTagsList = Object.values(selectedTags);
  const displayTags = selectedTagsList.slice(0, 3);
  const remainingCount = selectedCount - 3;
  
  // Updated validation - amount must be between 100 and 99999
  const isRechargeValid = rechargeAmount && 
    parseFloat(rechargeAmount) >= 100 && 
    parseFloat(rechargeAmount) <= 99999 && 
    reason.trim();
    
  const isDeptValid = selectedDepartmentId;

  return (
    <TagViewComponent
      corporateId={corporateId}
      corporateName={corporateName}
      tagData={{ tags: filteredTags }}
      loading={loading}
      loadingMore={loadingMore}
      hasMore={hasMore}
      totalElements={totalElements}
      currentPage={currentPage}
      totalPages={totalPages}
      onLoadMore={handleLoadMore}
      onBackClick={handleBackClick}
      onEditTag={handleEditTag}
      onBulkUpload={handleBulkUpload}
      onSelectTag={handleSelectTag}
      onSelectAll={handleSelectAll}
      onActivateSelected={handleActivateSelected}
      onDeactivateSelected={handleOpenDeactivateModal}
      onChangeDepartment={handleOpenDeptModal}
      selectedTags={selectedTags}
      selectedCount={selectedCount}
      activeTags={activeTags}
      inactiveTags={inactiveTags}
      notActivatedTags={notActivatedTags}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      searchTerm={searchTerm}
      onSearchChange={handleSearchChange}
      onSearch={handleSearch}
      filteredTags={filteredTags}
      selectAll={selectAll}
      onSelectAllTags={() => handleSelectAll(filteredTags, !selectAll)}
      showDepartmentFilter={showDepartmentFilter}
      onToggleDepartmentFilter={handleToggleDepartmentFilter}
      departmentFilter={departmentFilter}
      onDepartmentFilterChange={handleDepartmentFilterChange}
      departments={departments}
      onClearDepartmentFilter={handleClearDepartmentFilter}
      showBalanceFilter={showBalanceFilter}
      onToggleBalanceFilter={handleToggleBalanceFilter}
      tempBalanceFilterType={tempBalanceFilterType}
      onTempBalanceFilterTypeChange={handleTempBalanceFilterTypeChange}
      tempBalanceAmount={tempBalanceAmount}
      onTempBalanceAmountChange={handleTempBalanceAmountChange}
      onApplyBalanceFilter={handleApplyBalanceFilter}
      onClearBalanceFilter={handleClearBalanceFilter}
      showRechargeModal={showRechargeModal}
      rechargeAmount={rechargeAmount}
      reason={reason}
      rechargeLoading={rechargeLoading}
      showSuccessPopup={showSuccessPopup}
      rechargeResult={rechargeResult}
      onOpenRechargeModal={handleOpenRechargeModal}
      onCloseRechargeModal={handleCloseRechargeModal}
      onRechargeAmountChange={handleRechargeAmountChange}
      onReasonChange={handleReasonChange}
      onSubmitRecharge={handleSubmitRecharge}
      onCloseSuccessPopup={handleCloseSuccessPopup}
      isRechargeValid={isRechargeValid}
      showDeactivateModal={showDeactivateModal}
      deactivateLoading={deactivateLoading}
      onCloseDeactivateModal={handleCloseDeactivateModal}
      onConfirmDeactivate={handleConfirmDeactivate}
      displayTags={displayTags}
      remainingCount={remainingCount}
      showDeptModal={showDeptModal}
      deptSearchTerm={deptSearchTerm}
      onDeptSearchChange={setDeptSearchTerm}
      filteredDepartments={filteredDepartments}
      showDeptDropdown={showDeptDropdown}
      onSelectDepartment={handleSelectDepartment}
      selectedDepartmentName={selectedDepartmentName}
      deptChangeLoading={deptChangeLoading}
      onCloseDeptModal={handleCloseDeptModal}
      onSubmitDeptChange={handleSubmitDeptChange}
      isDeptValid={isDeptValid}
      deptSuccessPopup={deptSuccessPopup}
      deptChangeResult={deptChangeResult}
      onCloseDeptSuccessPopup={handleCloseDeptSuccessPopup}
      showBulkUploadModal={showBulkUploadModal}
      bulkUploading={bulkUploading}
      bulkUploadProgress={bulkUploadProgress}
      selectedFile={selectedFile}
      bulkUploadHeading={bulkUploadHeading}
      onFileSelect={handleFileSelect}
      onFileUpload={handleBulkFileUpload}
      onCloseBulkUploadModal={handleCloseBulkUploadModal}
      onCancelFile={handleCancelFile}
      showActivateSuccessPopup={showActivateSuccessPopup}
      activateResult={activateResult}
      onCloseActivateSuccessPopup={handleCloseActivateSuccessPopup}
      handleConfirmActivate={handleConfirmActivate}
      onNotActivatedSelectAll={handleNotActivatedSelectAll}
      notActivatedAllSelected={notActivatedAllSelected}
      notActivatedSelectedCount={notActivatedSelectedCount}
      notActivatedTotalCount={notActivatedTotalCount}
      departmentListForPopup={departmentListForPopup}
    />
  );
};

function mapStateToProps(state) {
  return { props: state };
}

export default connect(mapStateToProps, { getDataFromAPI })(TagViewDetailsContainer);